<template>
  <div class="about-page">
    <div class="gywmzhong">
      <h2 class="animate__animated animate__fadeInLeft wow">{{ t('about.companyOverview') }}</h2>
      <p class="animate__animated animate__fadeInLeftBig wow">/&emsp;{{ t('about.companyOverviewEn') }}</p>
      <div class="gywmrunqi">
        <div :style="{ backgroundImage: `url(${require('@/assets/images/about/门头图片.jpg')})` }"
             class="animate__animated animate__lightSpeedInLeft wow">
        </div>
        <div>
          <p class="animate__animated animate__fadeInRightBig wow">
            {{ t('about.companyDesc') }}
          </p>
        </div>
      </div>
    </div>

    <!-- 关于我们轮播图 -->
    <div class="office">
      <p class="animate__animated animate__fadeInTopLeft wow">{{ t('about.environmentTitle') }}</p>
      <span class="animate__animated animate__flipInY wow">{{ t('about.environmentSubtitle') }}</span>
    </div>
    <div class="container">
      <el-carousel height="500px">
        <el-carousel-item v-for="(img, index) in environmentImages" :key="index">
          <div :style="{ backgroundImage: `url(${img})` }"></div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 公司介绍视频 -->
    <div class="company-video-section">
      <div class="page-container">
        <div class="section-header text-center">
          <h2 class="section-title">{{ t('about.companyIntroTitle') }}</h2>
          <p class="section-desc">{{ t('about.companyIntroDesc') }}</p>
        </div>
        <div class="video-container">
          <el-image
              v-if="!isPlaying"
              :src="videoThumbnail"
              fit="cover"
              class="video-thumbnail"
              @click="playCompanyVideo"
          >
            <div class="play-button">
              <i class="el-icon-video-play"></i>
            </div>
          </el-image>
          <video
              v-else
              ref="companyVideo"
              controls
              autoplay
              class="company-video"
              @ended="stopVideo"
          >
            <source :src="videoSource" type="video/mp4">
            {{ t('about.videoNotSupported') }}
          </video>
        </div>
      </div>
    </div>

    <!-- 团队介绍（自动滚动走马灯） -->
    <div class="team-section">
      <div class="page-container">
        <div class="section-header text-center">
          <h2 class="section-title">{{ t('about.teamTitle') }}</h2>
          <p class="section-desc">{{ t('about.teamDesc') }}</p>
        </div>
        <div class="team-marquee-wrapper">
          <div class="team-marquee">
            <!-- 第一遍列表 -->
            <div class="team-member" v-for="(member, index) in teamMembers" :key="'first-' + index">
              <div class="member-avatar">
                <img :src="member.avatar" :alt="member.name">
              </div>
              <div class="member-info">
                <h3 class="member-name">{{ member.name }}</h3>
                <p class="member-position">{{ member.position }}</p>
                <p class="member-description">{{ member.description }}</p>
              </div>
            </div>
            <!-- 第二遍列表 -->
            <div class="team-member" v-for="(member, index) in teamMembers" :key="'second-' + index">
              <div class="member-avatar">
                <img :src="member.avatar" :alt="member.name">
              </div>
              <div class="member-info">
                <h3 class="member-name">{{ member.name }}</h3>
                <p class="member-position">{{ member.position }}</p>
                <p class="member-description">{{ member.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, nextTick} from 'vue';
import {useI18n} from 'vue-i18n';

export default {
  setup() {
    const {t} = useI18n();

    const videoThumbnail = ref(require('@/assets/images/about/门头图片.jpg'));
    const videoSource = ref('/videos/a.mp4');
    const isPlaying = ref(false);
    const companyVideo = ref(null);

    const environmentImages = ref([
      require('@/assets/images/about/banner8.jpg'),
      require('@/assets/images/about/banner7.jpg'),
      require('@/assets/images/about/banner5.jpg'),
      require('@/assets/images/about/banner6.jpg'),
    ]);

    const teamMembers = ref([
      {
        name: '韩国和祥泰数码科技有限公司',
        position: '韩国和祥泰数码科技有限公司',
        description: '程序化管理；细节化管理；执行力度和管理力度；整理、整顿，不断创新；与时俱进，打造完美',
        avatar: require('@/assets/images/about/门头图片.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: '韩国豪鸿株式会社',
        position: '韩国豪鸿株式会社',
        description: '程序化管理；细节化管理；执行力度和管理力度；整理、整顿，不断创新；与时俱进，打造完美',
        avatar: require('@/assets/images/about/门头图片.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: '苏州和祥泰新材料科技有限公司',
        position: '苏州和祥泰新材料科技有限公司',
        description: '程序化管理；细节化管理；执行力度和管理力度；整理、整顿，不断创新；与时俱进，打造完美',
        avatar: require('@/assets/images/about/门头图片.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: '威海艾莎包装制品有限公司',
        position: '威海艾莎包装制品有限公司',
        description: '程序化管理；细节化管理；执行力度和管理力度；整理、整顿，不断创新；与时俱进，打造完美',
        avatar: require('@/assets/images/about/门头图片.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: '河北澳鑫医药包装制品有限公司',
        position: '河北澳鑫医药包装制品有限公司',
        description: '程序化管理；细节化管理；执行力度和管理力度；整理、整顿，不断创新；与时俱进，打造完美',
        avatar: require('@/assets/images/about/门头图片.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: '威海海日水产食品有限公司',
        position: '威海海日水产食品有限公司',
        description: '程序化管理；细节化管理；执行力度和管理力度；整理、整顿，不断创新；与时俱进，打造完美',
        avatar: require('@/assets/images/about/门头图片.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
    ]);

    const playCompanyVideo = () => {
      isPlaying.value = true;
      nextTick(() => {
        if (companyVideo.value) {
          companyVideo.value.play();
        }
      });
    };

    const stopVideo = () => {
      isPlaying.value = false;
    };

    return {
      t,
      videoThumbnail,
      videoSource,
      isPlaying,
      companyVideo,
      teamMembers,
      environmentImages,
      playCompanyVideo,
      stopVideo
    };
  }
};
</script>
<style lang="scss" scoped>
.about-page {
  padding-top: 64px; // 修复顶部遮挡问题
}

.gywmzhong {
  margin: 5% 0 0 0;
  padding-bottom: 5%;
}

.gywmzhong > h2 {
  margin: 0 0 20px 15%;
  font-size: 36px;
  font-weight: 900;
}

.gywmzhong > p {
  color: rgb(134, 134, 134);
  margin: 0 0 20px 15%;
  font-family: Franklin Gothic Medium;
}

.gywmrunqi {
  width: 70%;
  margin: 0 auto;
  display: flex;
  padding-bottom: 5%;
}

.gywmrunqi > div {
  width: 100%;
}

.gywmrunqi > div:first-child {
  background-size: 100% 100%;
  height: 400px;
  filter: grayscale(30%);
}

.gywmrunqi > div:last-child > p {
  line-height: 30px;
  letter-spacing: 0.3px;
  color: rgb(134, 134, 134);
  padding: 0 50px 0 50px;
}

.office {
  width: 100%;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.office > p {
  font-size: 36px;
  font-weight: 900;
  margin: 0;
}

.office > span {
  font-size: 14px;
  color: rgb(134, 134, 134);
  font-family: Franklin Gothic Medium;
}

.container {
  width: 100%;
  margin: 0 auto;
  background-color: #f5f7fa;
  padding-bottom: 5%;

  ::v-deep(.el-carousel) {
    width: 80%;
    margin: 0 auto;
  }

  ::v-deep(.el-carousel__item) div {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
  }
}

.company-video-section {
  padding: 80px 0;
  background-color: #fff;

  .video-container {
    max-width: 900px;
    margin: 50px auto 0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    position: relative;

    .video-thumbnail {
      width: 100%;
      height: 500px;
      position: relative;
      cursor: pointer;

      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;

        i {
          font-size: 40px;
          color: #fff;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
          transform: translate(-50%, -50%) scale(1.1);
        }
      }
    }

    .company-video {
      width: 100%;
      height: 500px;
      object-fit: cover;
    }
  }
}

.team-section {
  padding: 80px 0;
  background-color: #f5f7fa;

  /* 不用grid，改成走马灯容器 */
  .team-container {
    display: none; /* 隐藏原有静态网格 */
  }

  /* 新增走马灯滚动容器 */
  .team-marquee-wrapper {
    width: 100%;
    overflow: hidden;
  }

  .team-marquee {
    display: flex;
    width: max-content;
    animation: marquee-scroll 20s linear infinite;

    .team-member {
      flex: 0 0 auto;
      width: 260px;
      margin-right: 30px;
      background-color: #fff;
      border-radius: 80px;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: transform 0.3s, box-shadow 0.3s;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      }

      .member-avatar {
        height: 250px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .member-info {
        padding: 20px;

        .member-name {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin: 0 0 5px;
        }

        .member-position {
          font-size: 14px;
          color: #409EFF;
          margin: 0 0 15px;
          font-weight: 500;
        }

        .member-description {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .member-social {
          display: flex;
          gap: 10px;

          a {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #666;
            transition: all 0.3s;

            &:hover {
              background-color: #409EFF;
              color: #fff;
            }

            i {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

.section-header {
  margin-bottom: 30px;

  .section-title {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;

    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 3px;
      background-color: #409EFF;
    }
  }

  .section-desc {
    font-size: 16px;
    color: #666;
    max-width: 700px;
    margin: 20px auto 0;
  }

  &.text-center {
    text-align: center;
  }
}

.page-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
@keyframes marquee-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
